import { Routes } from '@angular/router';
import { authGuard } from '@core/auth/auth.guard';
import { roleGuard } from '@core/auth/role.guard';
import { defaultProfileTabGuard } from '@core/auth/default-profile-tab.guard';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'equipment',
    pathMatch: 'full',
  },

  // Основная таблица оборудования
  {
    path: 'equipment',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/equipment/equipment-table/equipment-table.component').then(
        (m) => m.EquipmentTableComponent,
      ),
  },

  // Личный кабинет — shell + child routes под router-outlet. ТЗ 3.1: вкладки
  // Администрирование/Организации доступны только admin-роли (roleGuard).
  {
    path: 'profile',
    canActivate: [authGuard],
    loadComponent: () =>
      import('./features/profile/profile-shell/profile-shell.component').then(
        (m) => m.ProfileShellComponent,
      ),
    children: [
      // `/profile` без суффикса — admin на «Администрирование», остальные на
      // «Настройки». Резолв роли в defaultProfileTabGuard.
      {
        path: '',
        canActivate: [defaultProfileTabGuard],
        children: [],
        pathMatch: 'full',
      },
      {
        path: 'admin',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./features/profile/admin/user-list/user-list.component').then(
            (m) => m.UserListComponent,
          ),
      },
      {
        path: 'companies',
        canActivate: [roleGuard(['admin'])],
        loadComponent: () =>
          import('./features/profile/admin/company-list/company-list.component').then(
            (m) => m.CompanyListComponent,
          ),
      },
      {
        path: 'settings',
        loadComponent: () =>
          import('./features/profile/change-password/change-password.component').then(
            (m) => m.ChangePasswordComponent,
          ),
      },
    ],
  },

  // Fallback
  {
    path: '**',
    redirectTo: 'equipment',
  },
];
